import { apiClient } from './client';
import { SlotGame } from './slots';

export interface PublicReplay {
  betId: number;
  game: SlotGame | 'crash';
  name: string;
  amount: string;
  totalWin: string;
  play?: any;
  crash?: { crashPoint: number; cashedOut: boolean; cashMultiplier: number | null };
}

export const publicApi = {
  config: () => apiClient.get<{ botUsername: string | null }>('/public/config').then((r) => r.data),
  replay: (betId: number) =>
    apiClient.get<PublicReplay>(`/public/replay/${betId}`).then((r) => r.data),
};
